// extracted by mini-css-extract-plugin
module.exports = {"createUserForm":"create-user-form_createUserForm___WQyz","alertWindow":"create-user-form_alertWindow__3HMe1","loadingSubmit":"create-user-form_loadingSubmit__TI5NN"};